import { render, staticRenderFns } from "./CaseMTab.vue?vue&type=template&id=779a9472"
import script from "./CaseMTab.vue?vue&type=script&lang=js"
export * from "./CaseMTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports